<template>
  <div class="h5-container chat-page">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      class="top-bar"
      :title="currentConversation.otherNickname || ('用户' + currentConversation.otherId)"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    >
      <template #right>
        <span class="status" :class="{ online: currentConversation.online }">
          {{ currentConversation.online ? '在线' : '离线' }}
        </span>
      </template>
    </van-nav-bar>

    <!-- 消息列表 -->
    <div class="chat-body" ref="chatBody">
      <!-- 加载更多 -->
      <div class="load-more" v-if="hasMore" @click="loadMoreHistory">
        <span>{{ loadingHistory ? '加载中...' : '加载更多历史消息' }}</span>
      </div>

      <template v-for="(msg, index) in messageList">
        <!-- 时间分隔 -->
        <div class="time-divider" v-if="shouldShowTime(index)" :key="'t' + index">
          <span>{{ formatMsgTime(msg.createTime) }}</span>
        </div>
        <!-- 消息气泡 -->
        <div
          class="msg-item"
          :key="index"
          :class="String(msg.fromId) === String(adminId) ? 'mine' : 'other'"
        >
          <div class="avatar other-avatar" v-if="String(msg.fromId) !== String(adminId)">
            <van-icon name="user-o" size="18" color="#D4AF37" />
          </div>
          <div class="msg-content">
            <div class="sender-name">{{ String(msg.fromId) === String(adminId) ? '我' : (msg.fromNickname || '用户') }}</div>
            <div class="bubble" :class="'bubble-' + (msg.contentType || 'text')">
              <template v-if="!msg.contentType || msg.contentType === 'text'">{{ msg.content }}</template>
              <img v-else-if="msg.contentType === 'image'" :src="msg.content" class="msg-image" @click="previewImage(msg.content)" />
              <video v-else-if="msg.contentType === 'video'" :src="msg.content" class="msg-video" controls />
            </div>
<!--            <div class="msg-meta">-->
<!--              <span class="msg-time">{{ formatMsgTime(msg.createTime) }}</span>-->
<!--              <span-->
<!--                v-if="String(msg.fromId) === String(adminId)"-->
<!--                class="msg-status"-->
<!--                :class="{ read: msg.isRead === 1 }"-->
<!--              >-->
<!--                {{ msg.isRead === 1 ? '已读' : '未读' }}-->
<!--              </span>-->
<!--            </div>-->
          </div>
          <div class="avatar mine-avatar" v-if="String(msg.fromId) === String(adminId)">
            <van-icon name="service-o" size="18" color="#fff" />
          </div>
        </div>
      </template>
    </div>

    <!-- 输入区域 -->
    <div class="chat-footer">
      <input ref="imageInput" type="file" accept="image/*" style="display:none" @change="handleUploadImage" />
      <input ref="videoInput" type="file" accept="video/*" style="display:none" @change="handleUploadVideo" />
      <div class="upload-row">
        <button class="upload-btn" @click="$refs.imageInput.click()" :disabled="uploading">
          <van-icon name="photo" size="16" color="#D4AF37" /><span>图片</span>
        </button>
        <button class="upload-btn" @click="$refs.videoInput.click()" :disabled="uploading">
          <van-icon name="video" size="16" color="#D4AF37" /><span>视频</span>
        </button>
        <button class="upload-btn" @click="handleTransferToAdmin">
          <van-icon name="share-o" size="16" color="#D4AF37" /><span>转总部客服</span>
        </button>
      </div>
      <div class="input-row">
        <textarea
          v-model="inputText"
          class="msg-input"
          placeholder="输入消息..."
          @keyup.enter.exact="sendMessage"
          @input="autoResize"
          ref="msgInput"
          rows="1"
        />
        <button class="send-btn" @click="sendMessage" :disabled="!inputText.trim()">发送</button>
      </div>
    </div>

    <!-- 图片预览 -->
    <div class="image-preview" v-if="imagePreviewVisible" @click="imagePreviewVisible = false">
      <img :src="imagePreviewUrl" class="preview-img" />
    </div>
  </div>
</template>

<script>
import { memberInformation } from '@/api/mine'
import { getHistoryMessages, markConversationRead, uploadChatFile, transferToAdmin } from '@/api/chat'

export default {
  name: 'DlsChat',
  data() {
    return {
      adminId: '',
      fromNickname:'',
      userType: 2, // 代理商/内勤在 chat 协议中是服务端：1
      currentConversation: {
        conversationKey: '',
        otherId: '',
        otherNickname: '',
        otherUserType: 2,
        online: false
      },
      ws: null,
      wsConnected: false,
      heartbeatTimer: null,
      heartbeatTimeoutTimer: null,
      lastReceivedTime: 0,
      reconnectTimer: null,
      reconnectCount: 0,
      messageList: [],
      inputText: '',
      pageNum: 1,
      pageSize: 20,
      hasMore: true,
      loadingHistory: false,
      pendingMessages: [],
      markReadTimer: null,
      inited: false,
      uploading: false,
      imagePreviewVisible: false,
      imagePreviewUrl: ''
    }
  },
  created() {
    // 从路由参数构建当前会话信息
    const query = this.$route.query
    this.currentConversation = {
      conversationKey: query.conversationKey || '',
      otherId: String(query.otherId || ''),
      otherNickname: query.otherNickname ? decodeURIComponent(query.otherNickname) : '',
      otherUserType: query.otherUserType != null ? Number(query.otherUserType) : 2,
      online: query.online === '1'
    }
    this.init()
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    this.updateViewportHeight()
    // 延迟一帧再计算，确保地址栏收起后获取正确高度
    requestAnimationFrame(() => this.updateViewportHeight())
    setTimeout(() => this.updateViewportHeight(), 300)
    window.addEventListener('resize', this.updateViewportHeight)
    window.addEventListener('orientationchange', this.updateViewportHeight)
  },
  activated() {
    // keep-alive重新激活时，用延迟确保获取正确高度
    this.updateViewportHeight()
    requestAnimationFrame(() => {
      this.updateViewportHeight()
      this.$nextTick(() => this.scrollToBottom())
    })
    setTimeout(() => this.updateViewportHeight(), 300)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
    window.removeEventListener('resize', this.updateViewportHeight)
    window.removeEventListener('orientationchange', this.updateViewportHeight)
    this.destroyWebSocket()
  },
  methods: {
    updateViewportHeight() {
      document.documentElement.style.setProperty('--chat-height', `${window.innerHeight - 50}px`)
    },
    async init() {
      await this.getUserInfo()
      if (!this.adminId) return
      this.connectWebSocket()
      await this.loadHistory()
      this.scheduleMarkRead()
      this.inited = true
    },
    async getUserInfo() {
      try {
        const res = await memberInformation()
        if (res.code === 200 && res.data) {
          this.adminId = String(res.data.id || res.data.userId || '')
          this.fromNickname = (res.data.merchant + "-" +res.data.nickName) || ''
        }
      } catch (e) {
        console.error('获取用户信息失败', e)
      }
    },

    // ===== WebSocket =====
    buildWsUrl() {
      if (process.env.NODE_ENV === 'development') {
        return `ws://${window.location.hostname}:8080`
      }
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
      return `${protocol}//${window.location.host}`
    },
    connectWebSocket() {
      if (!this.adminId) return
      if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) return
      const fullUrl = `${this.buildWsUrl()}/ws/chat/${this.adminId}/${this.userType}`
      try {
        this.ws = new WebSocket(fullUrl)
        this.ws.binaryType = 'arraybuffer'

        this.ws.onopen = () => {
          this.wsConnected = true
          this.reconnectCount = 0
          this.lastReceivedTime = Date.now()
          this.startHeartbeat()
          if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer)
            this.reconnectTimer = null
          }
          this.flushPendingMessages()
        }

        this.ws.onmessage = async (event) => {
          this.lastReceivedTime = Date.now()
          this.clearHeartbeatTimeout()

          let data = event.data
          if (data instanceof Blob) {
            try { data = await data.text() } catch (e) { return }
          }
          if (data instanceof ArrayBuffer) {
            try { data = new TextDecoder('utf-8').decode(data) } catch (e) { return }
          }
          let msg
          try {
            msg = JSON.parse(data)
          } catch (e) {
            console.error('消息JSON解析失败', e, data)
            return
          }
          if (msg.msgType === 'heartbeat') return
          this.handleReceiveMessage(msg)
        }

        this.ws.onclose = () => {
          this.wsConnected = false
          this.stopHeartbeat()
          this.clearHeartbeatTimeout()
          this.autoReconnect()
        }

        this.ws.onerror = () => {
          // 交给 onclose 处理
        }
      } catch (e) {
        this.wsConnected = false
        this.autoReconnect()
      }
    },
    // 处理收到的消息：仅渲染当前会话的消息（用对方ID匹配，不依赖conversationKey格式）
    handleReceiveMessage(msg) {
      // 已读回执：对方读了我发的消息
      if (msg.msgType === 'readReceipt') {
        this.handleReadReceipt(msg)
        return
      }
      const otherId = String(this.currentConversation.otherId)
      if (String(msg.fromId) === otherId || String(msg.toId) === otherId) {
        // 空消息过滤（防止空气泡）
        if (!msg.content || !msg.content.trim()) {
          return
        }
        // 消息去重：防止重复回显
        const isDuplicate = this.messageList.some(m => {
          if (msg.id && m.id === msg.id) return true
          if (!msg.id && m.content === msg.content && String(m.fromId) === String(msg.fromId) && 
              new Date(m.createTime).getTime() === new Date(msg.createTime).getTime()) return true
          return false
        })
        if (isDuplicate) {
          return
        }
        this.messageList.push(msg)
        this.$nextTick(() => this.scrollToBottom())
        // 只有页面可见且消息来自对方时才标记已读
        if (!document.hidden && String(msg.fromId) !== String(this.adminId)) {
          msg.isRead = 1
          this.scheduleMarkRead()
        }
      }
      // 非当前会话的消息直接忽略，列表页会在返回后通过 loadConversationList 刷新
    },
    // 处理已读回执：对方读了我发的消息
    handleReadReceipt(receipt) {
      if (!receipt || receipt.conversationKey !== this.currentConversation.conversationKey) return
      this.messageList.forEach(msg => {
        if (String(msg.fromId) === String(this.adminId)) {
          msg.isRead = 1
        }
      })
    },
    // 心跳
    startHeartbeat() {
      this.stopHeartbeat()
      this.heartbeatTimer = setInterval(() => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify({ msgType: 'heartbeat' }))
          this.clearHeartbeatTimeout()
          this.heartbeatTimeoutTimer = setTimeout(() => {
            if (this.ws) {
              try { this.ws.close() } catch (e) {}
            }
          }, 10000)
        }
      }, 30000)
    },
    clearHeartbeatTimeout() {
      if (this.heartbeatTimeoutTimer) {
        clearTimeout(this.heartbeatTimeoutTimer)
        this.heartbeatTimeoutTimer = null
      }
    },
    stopHeartbeat() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer)
        this.heartbeatTimer = null
      }
      this.clearHeartbeatTimeout()
    },
    autoReconnect() {
      if (this.reconnectTimer) return
      this.reconnectCount++
      const delay = Math.min(this.reconnectCount * 3000, 30000)
      this.reconnectTimer = setTimeout(() => {
        this.reconnectTimer = null
        this.connectWebSocket()
      }, delay)
    },
    handleVisibilityChange() {
      if (document.visibilityState !== 'visible') return
      if (!this.inited || !this.adminId) return
      // 页面变为可见：把未读的对方消息标记为已读
      let hasUnread = false
      this.messageList.forEach(msg => {
        if (String(msg.fromId) !== String(this.adminId) && msg.isRead !== 1) {
          msg.isRead = 1
          hasUnread = true
        }
      })
      if (hasUnread) {
        this.scheduleMarkRead()
      }
      // WebSocket 健康检查
      if (!this.ws || this.ws.readyState === WebSocket.CLOSING || this.ws.readyState === WebSocket.CLOSED) {
        if (this.reconnectTimer) {
          clearTimeout(this.reconnectTimer)
          this.reconnectTimer = null
        }
        this.reconnectCount = 0
        this.connectWebSocket()
        return
      }
      if (this.lastReceivedTime && Date.now() - this.lastReceivedTime > 30000) {
        try { this.ws.close() } catch (e) {}
      }
    },
    destroyWebSocket() {
      this.stopHeartbeat()
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer)
        this.reconnectTimer = null
      }
      if (this.markReadTimer) {
        clearTimeout(this.markReadTimer)
        this.markReadTimer = null
      }
      if (this.ws) {
        try { this.ws.close() } catch (e) {}
        this.ws = null
      }
      this.wsConnected = false
    },

    // ===== 发送消息 =====
    // 输入框自动增高
    autoResize() {
      const el = this.$refs.msgInput
      if (!el) return
      el.style.height = 'auto'
      el.style.height = Math.min(el.scrollHeight, 120) + 'px'
    },

    sendMessage() {
      const content = this.inputText.trim()
      if (!content || !this.currentConversation.conversationKey) return

      const msg = {
        fromUserType: '2',
        fromNickname: this.fromNickname,
        toId: this.currentConversation.otherId,
        toUserType: this.currentConversation.otherUserType,
        content: content,
        contentType: 'text',
        msgType: 'chat',
        conversationKey: this.currentConversation.conversationKey
      }

      // 本地渲染
      const localMsg = {
        fromId: this.adminId,
        fromUserType: 2,
        toId: this.currentConversation.otherId,
        toUserType: this.currentConversation.otherUserType,
        content: content,
        contentType: 'text',
        msgType: 'chat',
        createTime: new Date().toISOString(),
        conversationKey: this.currentConversation.conversationKey,
        isRead: 0
      }
      this.messageList.push(localMsg)
      this.inputText = ''
      this.$nextTick(() => this.scrollToBottom())

      if (this.wsConnected && this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(msg))
      } else {
        this.pendingMessages.push(msg)
      }
    },
    // 补发缓存消息
    flushPendingMessages() {
      if (this.pendingMessages.length === 0) return
      this.pendingMessages.forEach(msg => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify(msg))
        }
      })
      this.pendingMessages = []
    },

    // ===== 历史消息 =====
    async loadHistory() {
      if (!this.currentConversation.conversationKey) return
      this.loadingHistory = true
      try {
        const res = await getHistoryMessages(
          this.currentConversation.conversationKey,
          this.pageNum,
          this.pageSize
        )
        if (res.code === 200) {
          const list = res.data || []
          const sorted = list.reverse()
          if (this.pageNum > 1) {
            this.messageList = [...sorted, ...this.messageList]
          } else {
            this.messageList = sorted
          }
          this.hasMore = list.length >= this.pageSize
          this.$nextTick(() => this.scrollToBottom())
        }
      } catch (e) {
        console.error('加载历史消息失败', e)
      } finally {
        this.loadingHistory = false
      }
    },
    loadMoreHistory() {
      if (!this.hasMore || this.loadingHistory) return
      this.pageNum++
      this.loadHistory()
    },

    // ===== 标记已读（防抖） =====
    scheduleMarkRead() {
      if (this.markReadTimer) return
      this.markReadTimer = setTimeout(() => {
        this.markReadTimer = null
        this.markRead()
      }, 2000)
    },
    async markRead() {
      if (!this.currentConversation.conversationKey || !this.adminId) return
      try {
        await markConversationRead(
          this.currentConversation.conversationKey,
          this.adminId,
          this.userType
        )
        // 标记成功后，本地把对方发的消息都设为已读
        this.messageList.forEach(msg => {
          if (String(msg.fromId) !== String(this.adminId)) {
            msg.isRead = 1
          }
        })
      } catch (e) {
        // 静默处理
      }
    },

    // ===== 工具 =====
    scrollToBottom() {
      const body = this.$refs.chatBody
      if (body) {
        body.scrollTop = body.scrollHeight
      }
    },
    // 上传图片
    async handleUploadImage(e) {
      const file = e.target.files[0]
      if (!file) return
      await this.uploadAndSend(file, 'image')
      e.target.value = ''
    },

    // 上传视频
    async handleUploadVideo(e) {
      const file = e.target.files[0]
      if (!file) return
      await this.uploadAndSend(file, 'video')
      e.target.value = ''
    },

    // 上传并发送文件消息
    async uploadAndSend(file, contentType) {
      this.uploading = true
      try {
        const res = await uploadChatFile(file)
        if (res.code === 200) {
          const url = res.url || res.data.url
          this.sendFileMessage(url, contentType)
        } else {
          this.$toast(res.msg || '上传失败')
        }
      } catch (err) {
        console.error('上传失败', err)
        this.$toast('上传失败')
      } finally {
        this.uploading = false
      }
    },

    // 发送文件消息
    sendFileMessage(url, contentType) {
      const msg = {
        fromUserType: '2',
        fromNickname: this.fromNickname,
        toId: this.currentConversation.otherId,
        toUserType: this.currentConversation.otherUserType,
        content: url,
        contentType: contentType,
        msgType: 'chat',
        conversationKey: this.currentConversation.conversationKey
      }
      const localMsg = {
        fromId: this.adminId,
        fromUserType: 2,
        toId: this.currentConversation.otherId,
        toUserType: this.currentConversation.otherUserType,
        content: url,
        contentType: contentType,
        msgType: 'chat',
        createTime: new Date().toISOString(),
        conversationKey: this.currentConversation.conversationKey,
        isRead: 0
      }
      this.messageList.push(localMsg)
      this.$nextTick(() => this.scrollToBottom())
      if (this.wsConnected && this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(msg))
      } else {
        this.pendingMessages.push(msg)
      }
    },

    // 预览图片
    previewImage(url) {
      this.imagePreviewUrl = url
      this.imagePreviewVisible = true
    },

    // 转内勤（平台客服）
    async handleTransferToAdmin() {
      try {
        await this.$dialog.confirm({
          title: '提示',
          message: '确定将该用户转接给璟点总部客服吗？'
        })
      } catch {
        return
      }
      try {
        const userId = this.currentConversation.otherId
        await transferToAdmin(userId)
        this.$toast('已转接平台客服')
        setTimeout(() => { this.$router.back() }, 800)
      } catch (e) {
        console.error('转内勤失败', e)
        this.$toast('转接失败，请稍后重试')
      }
    },

    goBack() {
      this.$router.replace('/app_dls_message')
      // this.$router.back()
    },
    // 是否需要显示时间分隔（间隔超过5分钟）
    shouldShowTime(index) {
      if (index === 0) return true
      const current = new Date(this.messageList[index].createTime).getTime()
      const prev = new Date(this.messageList[index - 1].createTime).getTime()
      return current - prev > 5 * 60 * 1000
    },
    // 消息时间格式化
    formatMsgTime(time) {
      if (!time) return ''
      const date = new Date(time)
      const now = new Date()
      const yesterday = new Date(now.getTime() - 86400000)
      const h = String(date.getHours()).padStart(2, '0')
      const m = String(date.getMinutes()).padStart(2, '0')
      if (date.toDateString() === now.toDateString()) {
        return `${h}:${m}`
      } else if (date.toDateString() === yesterday.toDateString()) {
        return `昨天 ${h}:${m}`
      } else if (date.getFullYear() === now.getFullYear()) {
        return `${date.getMonth() + 1}月${date.getDate()}日 ${h}:${m}`
      } else {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()} ${h}:${m}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
.h5-container.chat-page {
  background-color: #1A1A1A;
  display: flex;
  flex-direction: column;
  height: 100dvh; // 用CSS原生方案，自动适应浏览器工具栏
  overflow: hidden;
  position: relative;
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  flex-shrink: 0; // 顶部固定高度

  ::v-deep .van-nav-bar__title {
    color: #0f0f0f;
    font-weight: 600;
  }
  ::v-deep .van-nav-bar__text {
    color: #0f0f0f;
  }
  ::v-deep .van-icon-arrow-left {
    color: #0f0f0f;
  }

  .status {
    font-size: 12px;
    color: #555;
    &.online {
      color: #52c41a;
    }
  }
}

.chat-body {
  flex: 1; // 自适应填满剩余空间
  overflow-y: auto;
  padding: 12px;
  padding-bottom: 140px; // 留出输入区(约100px) + tabbar(44px)空间
  background: #1A1A1A;
  min-height: 0; // 允许flex子项收缩触发内部滚动
  -webkit-overflow-scrolling: touch; // iOS平滑滚动

  .time-divider {
    text-align: center;
    margin: 12px 0;

    span {
      display: inline-block;
      padding: 2px 10px;
      font-size: 11px;
      color: #888;
      background: rgba(255, 255, 255, 0.06);
      border-radius: 4px;
    }
  }

  .load-more {
    text-align: center;
    padding: 10px;
    font-size: 12px;
    color: #666;
    cursor: pointer;
  }

  .msg-item {
    display: flex;
    margin-bottom: 14px;
    align-items: flex-start;

    &.mine {
      justify-content: flex-end;
    }

    .avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      margin: 0 8px;
    }

    .other-avatar {
      background: #2a2a2a;
      border: 1px solid #D4AF37;
    }

    .mine-avatar {
      background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
    }

    .msg-content {
      display: flex;
      flex-direction: column;
      max-width: 70%;
      align-items: flex-start;
    }

    .sender-name {
      font-size: 11px;
      color: #888;
      margin-bottom: 3px;
      padding: 0 2px;
    }

    .bubble {
      max-width: 100%;
      padding: 9px 13px;
      border-radius: 8px;
      font-size: 14px;
      line-height: 1.5;
      word-break: break-all;
    }

    &.other .bubble {
      background: #2a2a2a;
      color: #e0e0e0;
    }

    &.mine .bubble {
      background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
      color: #0f0f0f;
    }

    /* 图片/视频消息 */
    .bubble-image,
    .bubble-video {
      padding: 0 !important;
      background: transparent !important;
      max-width: 86% !important;
      overflow: hidden;
      border-radius: 8px;
    }

    .msg-image {
      max-width: 180px;
      max-height: 180px;
      border-radius: 8px;
      display: block;
      cursor: pointer;
    }

    .msg-video {
      max-width: 220px;
      max-height: 220px;
      border-radius: 8px;
      display: block;
    }

    .msg-meta {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 3px;
      font-size: 11px;
      line-height: 1;

      .msg-time {
        color: #666;
      }

      .msg-status {
        color: #e6a23c;

        &.read {
          color: #52c41a;
        }
      }
    }

    &.mine .msg-content {
      align-items: flex-end;
    }
  }
}

.chat-footer {
  position: fixed; // 固定定位，不参与flex布局
  left: 0;
  right: 0;
  bottom: 44px; // tabbar高度
  display: flex;
  flex-direction: column;
  padding: 10px 12px;
  background: #1f1f1f;
  border-top: 1px solid rgba(212, 175, 55, 0.12);
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.4);
  z-index: 100;
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
  gap: 8px;

  .upload-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .input-row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .upload-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border: 1px solid rgba(212, 175, 55, 0.25);
    background: #262626;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
    color: #D4AF37;
    font-size: 12px;

    &:active {
      transform: scale(0.92);
      background: #2e2e2e;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .msg-input {
    flex: 1;
    min-width: 0;
    min-height: 38px;
    max-height: 120px;
    border: 1px solid #333;
    border-radius: 19px;
    padding: 9px 16px;
    font-size: 14px;
    outline: none;
    resize: none;
    line-height: 20px;
    background: #262626;
    color: #e0e0e0;
    font-family: inherit;
    background: #1A1A1A;
    color: #fff;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;

    &::placeholder {
      color: #666;
    }

    &:focus {
      border-color: rgba(212, 175, 55, 0.6);
      box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.12);
    }
  }

  .send-btn {
    height: 38px;
    padding: 0 20px;
    background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
    color: #0f0f0f;
    border: none;
    border-radius: 19px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    cursor: pointer;
    flex-shrink: 0;
    transition: transform 0.15s ease;

    &:active {
      transform: scale(0.96);
    }

    &:disabled {
      background: #3a3a3a;
      color: #777;
      cursor: not-allowed;
      box-shadow: none;
    }
  }
}

/* 图片预览 */
.image-preview {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;

  .preview-img {
    max-width: 95vw;
    max-height: 95vh;
    object-fit: contain;
  }
}

/* PC适配：参考 home.vue / mine.vue 约定，放大头像、气泡、输入区 */
@media screen and (min-width: 768px) {
  .chat-page {
    align-items: stretch; // 覆盖全局.h5-container的align-items:center，让子元素撑满宽度
    justify-content: flex-start; // 覆盖全局的justify-content:center
    height: calc(100vh - 80px); // PC端tabbar更高（80px）
    min-height: calc(100vh - 80px);
    padding-bottom: 80px; // PC端留出更多tabbar空间
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.5);
  }

  .top-bar {
    height: 70px; // PC端nav-bar更高
  }

  .chat-body {
    padding: 16px;

    .msg-item {
      margin-bottom: 18px;

      .avatar {
        width: 48px;
        height: 48px;
      }

      .msg-content {
        max-width: 400px;
      }

      .bubble {
        font-size: 16px;
        padding: 12px 16px;
      }

      .msg-image {
        max-width: 240px;
        max-height: 240px;
      }

      .msg-video {
        max-width: 320px;
        max-height: 320px;
      }
    }
  }

  .chat-footer {
    flex-shrink: 0;
    padding: 14px 16px;
    padding-bottom: 14px; // PC端无需安全区
    gap: 12px;

    .upload-btn {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 4px 10px;
      border: 1px solid rgba(212, 175, 55, 0.25);
      background: #262626;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s ease;
      color: #D4AF37;
      font-size: 12px;

      &:active {
        transform: scale(0.92);
        background: #2e2e2e;
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }

    .msg-input {
      min-height: 48px;
      max-height: 150px;
      border-radius: 24px;
      font-size: 16px;
      padding: 12px 20px;
      line-height: 24px;
    }

    .send-btn {
      height: 48px;
      padding: 0 28px;
      border-radius: 24px;
      font-size: 16px;
    }
  }
}
</style>
